<script setup lang="ts">
import { useLoadingStore } from "@/stores/loading";
useLoadingStore();
</script>
<template>
    <div id="loading" tabindex="-10" class="z-index-loading" v-if="LoadingStore.loading || showLoading">
        <div class="progress mb-3 fixed-top">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"
                aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Processando</div>
        </div>
    </div>
</template>


<script lang="ts">
import { mapStores } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
    name: "LoadingContentComponent",
    data() {
        return {
            showLoading: false
        };
    },
    computed: {
        ...mapStores(useLoadingStore)
    },
    watch: {
        'loadingStore.loading': function () {
            this.showLoading = this.LoadingStore.loading;
        }
    },
    mounted() {
        document.addEventListener('DOMContentLoaded', () =>
            this.wait(1000).then(() => this.setVisible(false))
        );
    },
    methods: {
        wait(delay = 0) {
            return new Promise(resolve => setTimeout(resolve, delay));
        },
        setVisible(visible: boolean) {
            this.showLoading = visible;
        }
    }
});
</script>

<style>
#loading {
    display: flex;
    position: fixed;
    z-index: 1065;
    width: 100%;
    height: 100%;
    background-color: rgba(192, 192, 192, 0.5);
    background-repeat: no-repeat;
    background-position: center;
}

.vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    right: 49%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 1066;
}

.vertical-bottom {
    margin: 0;
    position: absolute;
    top: 80%;
    right: 10%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 1066;
}

.z-index-loading {
    z-index: 1065;
}

.z-index-loading2 {
    z-index: 1075;
}

.line {
    border-right: 2px solid rgba(255, 255, 255, 0.75);
    color: rgba(255, 255, 255, 0.75);
    font-family: "Special Elite", monospace;
    font-size: 3em;
    text-align: center;
    margin: 0 auto;
    white-space: nowrap;
    overflow: hidden;
}

.progress {
    border-radius: 0;
}

.progress-bar {
    background-color: #f58634;
}

.typing-animation {
    animation: blinkCursor 500ms steps(40) infinite normal,
        typing 4s steps(40) 3s normal both;
    animation-delay: 5s;
    animation-iteration-count: infinite;
    animation-direction: forward;
}

@keyframes typing {
    from {
        width: 0;
    }

    to {
        width: 16em;
    }
}

@keyframes blinkCursor {
    from {
        border-right-color: rgba(255, 255, 255, 0.75);
    }

    to {
        border-right-color: transparent;
    }
}
</style>